import { render, staticRenderFns } from "./MdnRequest.vue?vue&type=template&id=31239d84&scoped=true"
import script from "./MdnRequest.vue?vue&type=script&lang=js"
export * from "./MdnRequest.vue?vue&type=script&lang=js"
import style0 from "./MdnRequest.vue?vue&type=style&index=0&id=31239d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31239d84",
  null
  
)

export default component.exports